'use strict';
const Router    = require('autor');
const TitleCard = require('./title-card.js');

class Route extends Router.Route {
  load(resolve) {
    resolve();
    window.scrollTo( 0, 0 );
  }

  routeDidUnmount() {
    document.body.classList.remove('home');
    document.body.classList.remove('home-menu');
    document.getElementById('title-card').style.display = 'none';
    document.getElementById('title-card').classList.remove('title-card--animating');
  }

  bootstrap(route) {
    document.getElementById('title-card').classList.add('title-card--animating');
    document.getElementById('title-card').classList.remove('menu');
    TitleCard.animate();
    document.getElementById('title-card').style.display = 'block';
    document.title = 'All Conference';
    document.body.classList.add('home');
    document.querySelector('main').innerHTML = '';
  }

}

module.exports = Route;



// WEBPACK FOOTER //
// ./src/js/home.service.js